// extracted by mini-css-extract-plugin
export var blog = "homepage-blog-module--blog--pl8iO";
export var blogs = "homepage-blog-module--blogs--c3j5N";
export var blogs_container = "homepage-blog-module--blogs_container--LJ3+E";
export var description = "homepage-blog-module--description--IMtSX";
export var image = "homepage-blog-module--image--jGseK";
export var image_container = "homepage-blog-module--image_container--ZZQho";
export var read_more = "homepage-blog-module--read_more--yd6u1";
export var right_scroll_adjustment = "homepage-blog-module--right_scroll_adjustment--cjejm";
export var separator = "homepage-blog-module--separator--BG5+2";